import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import currencySymbolMap from "currency-symbol-map";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Autocomplete, Box, TextField } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  AllCountriesModel,
  AppraisalDetailsModelForCM,
  AppraisalsDetailsModelForEquity,
} from "../../../all_Interfaces";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { updateAppraisalDetailsForUSAppraisal } from "../../../redux/slices/AppraisalDetailsForUSAppraisalSlice";
import dayjs, { Dayjs } from "dayjs";
import { updateAppraisalDetailsForCM } from "../../../redux/slices/AppraisalDetailsForCMSlice";
import { error } from "console";

export const AppraisalValuesForCM = (props: any) => {
  const dispatch = useAppDispatch();
  const [currencyObj, setCurrencyObj] = useState<AllCountriesModel>({
    id: 4,
    countryName: "United States of America",
    countryCode: "USD",
    localId: "en_US",
  });
  const today: dayjs.Dayjs = dayjs();
  const toDay: string = today.format("DD-MM-YYYY HH:mm:ss");
  const [currencySymbol, setCurrencySymbol] = useState<string>("");
  const [appraisalsDetails, setAppraisalDetails] =
    useState<AppraisalDetailsModelForCM>({
      currencySelected: "",
      propertyValueAsIs: null,
      propertyValueAsIsDate: "",
      capRateAsIs: null,
      propertyValueStabilized: null,
      propertyValueStabilizedDate: "",
      capRateStabilized: null,
      propertyInsurableValue: null,
      propertyLandValue: null,
      reportDate: "",
    });

  const appraisalDetailsForCM: AppraisalDetailsModelForCM = useAppSelector(
    (state) => state.AppraisalDetailsForCM.data
  );

  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  const submitEvent: boolean = useAppSelector(
    (state) => state.AppraisalSubmitEvent.data
  );

  useEffect(() => {
    setIsSubmit(submitEvent);
  }, [submitEvent]);
  useEffect(() => {
    setAppraisalDetails({
      ...appraisalsDetails,
      propertyValueAsIs:
        appraisalDetailsForCM.propertyValueAsIs != null
          ? appraisalDetailsForCM.propertyValueAsIs
          : null,
      capRateAsIs:
        appraisalDetailsForCM.capRateAsIs != null
          ? appraisalDetailsForCM.capRateAsIs
          : null,
      currencySelected:
        appraisalDetailsForCM.currencySelected != null
          ? appraisalDetailsForCM.currencySelected
          : "",
      propertyValueAsIsDate:
        appraisalDetailsForCM.propertyValueAsIsDate != null
          ? appraisalDetailsForCM.propertyValueAsIsDate
          : dayjs(today).format("MM-DD-YYYY"),
      propertyValueStabilized:
        appraisalDetailsForCM.propertyValueStabilized != null
          ? appraisalDetailsForCM.propertyValueStabilized
          : null,
      capRateStabilized:
        appraisalDetailsForCM.capRateStabilized != null
          ? appraisalDetailsForCM.capRateStabilized
          : null,
      propertyValueStabilizedDate:
        appraisalDetailsForCM.propertyValueStabilizedDate != null
          ? appraisalDetailsForCM.propertyValueStabilizedDate
          : "",
      propertyInsurableValue:
        appraisalDetailsForCM.propertyInsurableValue != null
          ? appraisalDetailsForCM.propertyInsurableValue
          : null,
      propertyLandValue:
        appraisalDetailsForCM.propertyLandValue != null
          ? appraisalDetailsForCM.propertyLandValue
          : null,
      reportDate:
        appraisalDetailsForCM.reportDate != null
          ? appraisalDetailsForCM.reportDate
          : "",
    });
    var countriesData:AllCountriesModel[] = [...props.countriesData];
    var cur:string = appraisalDetailsForCM.currencySelected != ""? appraisalDetailsForCM.currencySelected:"USD";
    var a = countriesData.find((a) =>  a.countryCode == cur);
    if(a != undefined)
    setCurrencyObj(a);
  }, [appraisalDetailsForCM]);

  useEffect(() => {
    if (currencyObj?.countryCode != "ZH") {
      setCurrencySymbol(currencySymbolMap(currencyObj.countryCode) as string);
    } else {
      setCurrencySymbol("ZH");
    }
  }, [currencyObj]);

  console.log(appraisalsDetails);

  const handleCurrencyChange = (value: AllCountriesModel) => {
    setCurrencyObj(value);
    dispatch(
      updateAppraisalDetailsForCM({
        ...appraisalsDetails,
        currencySelected: value.countryCode,
      })
    );
  };

  const formatNumberWithCommas = (num: number | string | null) => {
    if(num != null)
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');

    return '';
  }
  const handlePropertyValueAsIsChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForCM({
        ...appraisalsDetails,
        propertyValueAsIs: formatedValue,
      })
    );
  }
  };

  const handleCapRateAsIsChange = (value: number) => {
    dispatch(
      updateAppraisalDetailsForCM({ ...appraisalsDetails, capRateAsIs: value })
    );
  };

  const handlePropertyValueAsIsDateChange = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForCM({
          ...appraisalsDetails,
          propertyValueAsIsDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handleReportDateChange = (d: Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForCM({
          ...appraisalsDetails,
          reportDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handlePropertyValueStabilizedChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForCM({
        ...appraisalsDetails,
        propertyValueStabilized: formatedValue,
      })
    );}
  };

  const handleCapRateStabilizedChange = (value: number) => {
    dispatch(
      updateAppraisalDetailsForCM({
        ...appraisalsDetails,
        capRateStabilized: value,
      })
    );
  };

  const handlePropertyValueStabilizedDateChange = (d: dayjs.Dayjs | null) => {
    if (d != null) {
      dispatch(
        updateAppraisalDetailsForCM({
          ...appraisalsDetails,
          propertyValueStabilizedDate: d.format("MM-DD-YYYY"),
        })
      );
    }
  };

  const handlePropertyLandValueChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForCM({
        ...appraisalsDetails,
        propertyLandValue: formatedValue,
      })
    );}
  };

  const handlePropertyInsurableValueChange = (value: string) => {
    const plainNumber = value.replace(/,/g,'');
    if(!isNaN(Number(plainNumber))){
      var formatedValue = formatNumberWithCommas(plainNumber);
    dispatch(
      updateAppraisalDetailsForCM({
        ...appraisalsDetails,
        propertyInsurableValue: formatedValue,
      })
    );}
  };

  // const handleCurrentAppraisalValueChange = (value: number) => {
  //   dispatch(updateAppraisalDetailsForCM({...appraisalsDetails,currentAppraisalValue:value}));
  // }

  // const handleEffectiveDateOfValue = (d: Dayjs | null) => {
  //   if (d != null) {
  //     dispatch(
  //       updateAppraisalDetailsForUSAppraisal({
  //         ...appraisalsDetails,
  //         effectiveDateOfValue: d.format("MM-DD-YYYY"),
  //       })
  //     );
  //   }
  // };

  return (
    <TableContainer component={Paper}>
      <Table
        sx={{ minWidth: 650 }}
        size="small"
        aria-label="a dense table"
        className="appraisal-value-table"
      >
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell>Property Values</TableCell>
            <TableCell>Cap Rate <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>Property Value Date <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>Report Date <span style={{color:'red'}}>*</span></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>As-Is <span style={{color:'red'}}>*</span></TableCell>
            <TableCell>
              <Autocomplete
                clearIcon={null}
                id="Currency"
                readOnly={props.flagToDisableControlesForAppraisal || props.view}
                options={props.countriesData.sort((a: any, b: any) =>
                  a.countryCode.localeCompare(b.countryCode)
                )}
                value={currencyObj}
                getOptionLabel={(option: AllCountriesModel) => {
                  return option.countryCode;
                }}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.countryCode}
                  </Box>
                )}
                onChange={(e, value) => {
                  handleCurrencyChange(value as AllCountriesModel);
                }}
                sx={{ width: 120 }}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  name="PropertyValueAsIs"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  type="text"
                  id="outlined-adornment-amount"
                  error={!appraisalsDetails.propertyValueAsIs && isSubmit}
                  value={formatNumberWithCommas(appraisalsDetails.propertyValueAsIs)}
                  onChange={(e) =>
                    handlePropertyValueAsIsChange(e.target.value)
                  }
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  name="CapRateAsIs"
                  type="number"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  value={appraisalsDetails.capRateAsIs}
                  error={!appraisalsDetails.capRateAsIs && isSubmit}
                  onChange={(e) =>
                    handleCapRateAsIsChange(parseFloat(e.target.value))
                  }
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{overflowY:'hidden'}} components={["DatePicker"]}>
                  <DatePicker
                    name="PropertyValueAsIsDate"
                    readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                    format="MMM-DD-YYYY"
                    value={
                      appraisalsDetails.propertyValueAsIsDate === "" ||
                        appraisalsDetails.propertyValueAsIsDate == null
                        ? null
                        : dayjs(
                          appraisalsDetails.propertyValueAsIsDate,
                          "MM-DD-YYYY"
                        )
                    }
                    views={["month", "day", "year"]}
                    onChange={(newValue: Dayjs | null) =>
                      handlePropertyValueAsIsDateChange(newValue)
                    }
                    slotProps={{ textField: { size: "small",error:!appraisalsDetails.propertyValueAsIsDate && isSubmit,placeholder:"MMM-DD-YYYY" } }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </TableCell>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{overflowY:'hidden'}} components={["DatePicker"]}>
                  <DatePicker
                    name="ReportDate"
                    format="MMM-DD-YYYY"
                    readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                    value={
                      appraisalsDetails.reportDate === "" ||
                        appraisalsDetails.reportDate == null
                        ? null
                        : dayjs(appraisalsDetails.reportDate, "MM-DD-YYYY")
                    }
                    views={["month", "day", "year"]}
                    onChange={(newValue: Dayjs | null) =>
                      handleReportDateChange(newValue)
                    }
                    slotProps={{ textField: { size: "small",error:!appraisalsDetails.reportDate && isSubmit,placeholder:"MMM-DD-YYYY" } }}

                  />
                </DemoContainer>
              </LocalizationProvider>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span className="table-link-wrap">Stabilized</span>
            </TableCell>
            <TableCell> </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  type="text"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  onChange={(e) =>
                    handlePropertyValueStabilizedChange(e.target.value)
                  }
                  value={formatNumberWithCommas(appraisalsDetails.propertyValueStabilized)}
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  value={appraisalsDetails.capRateStabilized}
                  type="decimal"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  onChange={(e) =>
                    handleCapRateStabilizedChange(parseFloat(e.target.value))
                  }
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">%</InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer sx={{overflowY:'hidden'}} components={["DatePicker"]}>
                  <DatePicker
                    name="PropertyValueStabilizedDate"
                    readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                    format="MMM-DD-YYYY"
                    onChange={(newValue: Dayjs | null) =>
                      handlePropertyValueStabilizedDateChange(newValue)
                    }
                    value={
                      appraisalsDetails.propertyValueStabilizedDate === "" ||
                        appraisalsDetails.propertyValueStabilizedDate == null
                        ? null
                        : dayjs(
                          appraisalsDetails.propertyValueStabilizedDate,
                          "MM-DD-YYYY"
                        )
                    }
                    views={["month", "day", "year"]}
                    slotProps={{ textField: { size: "small", placeholder:"MMM-DD-YYYY" } }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </TableCell>
            <TableCell></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span className="table-link-wrap">Land Value</span>
            </TableCell>
            <TableCell> </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  type="text"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  value={formatNumberWithCommas(appraisalsDetails.propertyLandValue)}
                  onChange={(e) =>
                    handlePropertyLandValueChange(e.target.value)
                  }
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <span className="table-link-wrap">Insurable Value</span>
            </TableCell>
            <TableCell> </TableCell>
            <TableCell>
              <FormControl size="small">
                <OutlinedInput
                  type="text"
                  readOnly={(props.flagToDisableControlesForAppraisal || props.view) && !props.postEditForAdmin}
                  value={formatNumberWithCommas(appraisalsDetails.propertyInsurableValue)}
                  onChange={(e) =>
                    handlePropertyInsurableValueChange(e.target.value)
                  }
                  id="outlined-adornment-amount"
                  startAdornment={
                    <InputAdornment position="start">
                      {currencySymbol}
                    </InputAdornment>
                  }
                />
              </FormControl>
            </TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
